/* CardAvatarFrame.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._37wbyuDIqT%7Bjustify-content%3Acenter%7D%0A._39xV02pJKa%7Bwidth%3A3pc%7D%0A._0jFU0VpJKa%7Bheight%3A3pc%7D%0A._3YEZNOdnbC%7Bflex-shrink%3A0%7D%0A._39xV02JgOI%7Bwidth%3A6pc%7D%0A._0jFU0VJgOI%7Bheight%3A6pc%7D%0A._1VJPcaFzSL%7Btransform%3Ascale(.5625)%7D%0A._0yKXXaDIqT%7Btransform-origin%3Acenter%7D%0A._1uo2ZfTcEg%7Bclip-path%3Apolygon(45%25%201.33975%25%2C46.5798%25%20.60307%25%2C48.26352%25%20.15192%25%2C50%25%200%2C51.73648%25%20.15192%25%2C53.4202%25%20.60307%25%2C55%25%201.33975%25%2C89.64102%25%2021.33975%25%2C91.06889%25%2022.33956%25%2C92.30146%25%2023.57212%25%2C93.30127%25%2025%25%2C94.03794%25%2026.5798%25%2C94.48909%25%2028.26352%25%2C94.64102%25%2030%25%2C94.64102%25%2070%25%2C94.48909%25%2071.73648%25%2C94.03794%25%2073.4202%25%2C93.30127%25%2075%25%2C92.30146%25%2076.42788%25%2C91.06889%25%2077.66044%25%2C89.64102%25%2078.66025%25%2C55%25%2098.66025%25%2C53.4202%25%2099.39693%25%2C51.73648%25%2099.84808%25%2C50%25%20100%25%2C48.26352%25%2099.84808%25%2C46.5798%25%2099.39693%25%2C45%25%2098.66025%25%2C10.35898%25%2078.66025%25%2C8.93111%25%2077.66044%25%2C7.69854%25%2076.42788%25%2C6.69873%25%2075%25%2C5.96206%25%2073.4202%25%2C5.51091%25%2071.73648%25%2C5.35898%25%2070%25%2C5.35898%25%2030%25%2C5.51091%25%2028.26352%25%2C5.96206%25%2026.5798%25%2C6.69873%25%2025%25%2C7.69854%25%2023.57212%25%2C8.93111%25%2022.33956%25%2C10.35898%25%2021.33975%25)%7D%0A._3Uxj39vLZJ%3Eimg%7Bdisplay%3Ablock%7D%0A._1f4A43N91d%3Eimg%7Bwidth%3A100%25%7D%0A._2nmIiEN91d%3Eimg%7Bheight%3A100%25%7D%0A._3XtUJZiObl%3Eimg%7B-o-object-fit%3Acover%3Bobject-fit%3Acover%7D%0A._0NjqGzDIqT%3Eimg%7B-o-object-position%3Acenter%3Bobject-position%3Acenter%7D");















import React from 'react';
import Avatar from '@atlaskit/avatar/avatar';
import { Box } from '@atlaskit/primitives/compiled/box';
const styles = {
  frame: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02pJKa _0jFU0VpJKa",
  avatar: "_3YEZNOdnbC _39xV02JgOI _0jFU0VJgOI _1VJPcaFzSL _0yKXXaDIqT",
  hexagon: "_1uo2ZfTcEg"
};

// Compiled supports the child selector needed to size consumer-provided images.
const imageStyles = null;
export type CardAvatarFrameProps = {
  /** Non-interactive content. Direct img children (including ADS Image) are sized automatically. */
  children?: React.ReactNode;
  /** Accessible name for the fallback avatar. Omit when the avatar is decorative. */
  name?: string;
  /** Crop the content to the rounded ADS hexagon. Defaults to false. */
  isHexagon?: boolean;
};

/** Size and center avatar content, or an ADS fallback, within the card's layout slot. */
export const CardAvatarFrame: (props: CardAvatarFrameProps) => React.JSX.Element = ({
  children,
  name,
  isHexagon = false
}) => <Box xcss={styles.frame}>
		<div className={ax([styles.avatar, "_3Uxj39vLZJ _1f4A43N91d _2nmIiEN91d _3XtUJZiObl _0NjqGzDIqT", isHexagon && styles.hexagon])}>
			{children ?? <Avatar name={name} appearance={isHexagon ? 'hexagon' : 'circle'} size="xlarge" />}
		</div>
	</Box>;